import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import { EstablishmentProvider } from "@/components/EstablishmentOnboarding";
import Dashboard from "@/pages/Dashboard";
import AnalysisCompose from "@/pages/AnalysisCompose";
import AnalysisResult from "@/pages/AnalysisResult";
import AnalysisHistory from "@/pages/AnalysisHistory";
import Reference from "@/pages/Reference";
import PatientHistory from "@/pages/PatientHistory";
import PatientView from "@/pages/PatientView";
import HASReference from "@/pages/HASReference";
import Login from "@/pages/Login";
import AdminUsers from "@/pages/AdminUsers";

function ProtectedRoute({ children }) {
  const token = sessionStorage.getItem("access_token");
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="app-container">
      <BrowserRouter>
        <EstablishmentProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="analysis/compose" element={<AnalysisCompose />} />
              <Route path="new-analysis" element={<AnalysisCompose />} />
              <Route path="analysis/:id" element={<AnalysisResult />} />
              <Route path="history" element={<AnalysisHistory />} />
              <Route path="patient-history" element={<PatientHistory />} />
              <Route path="patient/:patientId" element={<PatientView />} />
              <Route path="patient/:patientId/history" element={<PatientView />} />
              <Route path="reference" element={<Reference />} />
              <Route path="has-reference" element={<HASReference />} />
              <Route path="admin/users" element={<AdminUsers />} />
            </Route>
          </Routes>
        </EstablishmentProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
